import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

document.querySelectorAll(".element-largecallout").forEach((el) => {
  const chars = el.querySelectorAll(".element-content-wrapped .word em");

  gsap
    .timeline({
      scrollTrigger: {
        trigger: el.querySelector(".element-container"),
        start: () => {
          const siteHeaderHeight = document.querySelector(".site-header").offsetHeight;

          return `top ${siteHeaderHeight}`;
        },
        end: "+=125%",
        pin: true,
        scrub: 0.5,
        markers: false,
      },
    })
    .set(
      chars,
      {
        opacity: 1,
        stagger: 0.1,
      },
      0.1,
    );
});
